module.exports = __webpack_public_path__ + "img/jp_strawberry.c4b71228.jpg";